import React, {useEffect, useState} from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import './ScrollToTopButton.css';

function ScrollToTopButton() {
    const [verticalPosition, setVerticalPosition] = useState(0);
    const [showButton, setShowButton] = useState(false);

    // Register event listener to track changes in scroll position
    useEffect(() => {
        const isVisibile = () => {
            const position = window.pageYOffset;
            setVerticalPosition(position);
        };

        window.addEventListener("scroll", isVisibile);
        return () => {
            window.removeEventListener("scroll", isVisibile);
        };
    }, []);

    // Debounce changes so changes only occur when a user has finished scrolling
    useEffect(() => {
        const timeout = setTimeout(() => {
            if (verticalPosition > 100) {
                setShowButton(true);
            } else {
                setShowButton(false);
            }
        }, 100);

        return () => clearTimeout(timeout);
    }, [verticalPosition]);

    const scrollToTop = () => {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'auto' // Scroll smooth is not supported on Safari
        });
    };

    return (
        <Button type="button" title="ScrollToTop" onClick={scrollToTop} className="scrollToTop" hidden={!showButton} >
            <FontAwesomeIcon icon={faChevronUp} size={"xl"} />
        </Button>
    );
}

export default ScrollToTopButton;